// Small inline icon set for the Marketing page. Inline SVG rather than an
// icon dependency: it's a handful of glyphs, they inherit currentColor, and
// this app has deliberately avoided adding libraries for small things.

export const GridIcon = (props) => (
  <svg viewBox="0 0 16 16" width="15" height="15" fill="currentColor" aria-hidden {...props}>
    <rect x="1" y="1" width="6" height="6" rx="1.5" />
    <rect x="9" y="1" width="6" height="6" rx="1.5" />
    <rect x="1" y="9" width="6" height="6" rx="1.5" />
    <rect x="9" y="9" width="6" height="6" rx="1.5" />
  </svg>
);

export const CalendarIcon = (props) => (
  <svg viewBox="0 0 16 16" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden {...props}>
    <rect x="1.75" y="2.75" width="12.5" height="11.5" rx="2" />
    <path d="M1.75 6.25h12.5M5.25 1.5v2.5M10.75 1.5v2.5" strokeLinecap="round" />
  </svg>
);

// A document with ruled lines and a currency mark — an invoice, not a plain
// page. Same 16-unit box and stroke weight as the rest of the set.
export const InvoiceIcon = (props) => (
  <svg viewBox="0 0 16 16" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden {...props}>
    <path d="M3.25 1.75h9.5v12.5l-2-1.25-2 1.25-2-1.25-2 1.25z" strokeLinejoin="round" />
    <path d="M6 5.25h4M6 8.25h4" strokeLinecap="round" />
  </svg>
);

export const SearchIcon = (props) => (
  <svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden {...props}>
    <circle cx="7" cy="7" r="4.75" />
    <path d="M10.5 10.5 14 14" strokeLinecap="round" />
  </svg>
);

export const InstagramIcon = (props) => (
  <svg viewBox="0 0 16 16" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="1.4" aria-hidden {...props}>
    <rect x="1.75" y="1.75" width="12.5" height="12.5" rx="4" />
    <circle cx="8" cy="8" r="3.1" />
    <circle cx="11.9" cy="4.1" r="0.9" fill="currentColor" stroke="none" />
  </svg>
);

export const CommentIcon = (props) => (
  <svg viewBox="0 0 16 16" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="1.4" aria-hidden {...props}>
    <path d="M14 7.6c0 3-2.7 5.4-6 5.4a7 7 0 0 1-1.8-.23L2.5 14l1.05-2.6A5.1 5.1 0 0 1 2 7.6C2 4.6 4.7 2.2 8 2.2s6 2.4 6 5.4Z" strokeLinejoin="round" />
  </svg>
);

export const UploadIcon = (props) => (
  <svg viewBox="0 0 16 16" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden {...props}>
    <path d="M8 11V2.5M4.75 5.75 8 2.5l3.25 3.25" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2.5 10.5v2A1.5 1.5 0 0 0 4 14h8a1.5 1.5 0 0 0 1.5-1.5v-2" strokeLinecap="round" />
  </svg>
);

export const PlusCircleIcon = (props) => (
  <svg viewBox="0 0 16 16" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden {...props}>
    <circle cx="8" cy="8" r="6.25" />
    <path d="M8 5.25v5.5M5.25 8h5.5" strokeLinecap="round" />
  </svg>
);

export const CheckCircleIcon = (props) => (
  <svg viewBox="0 0 16 16" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.7" aria-hidden {...props}>
    <circle cx="8" cy="8" r="6.25" />
    <path d="m5.4 8.2 1.9 1.9 3.4-3.9" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const DragHandleIcon = (props) => (
  <svg viewBox="0 0 16 16" width="14" height="14" fill="currentColor" aria-hidden {...props}>
    <circle cx="6" cy="4" r="1.25" />
    <circle cx="10" cy="4" r="1.25" />
    <circle cx="6" cy="8" r="1.25" />
    <circle cx="10" cy="8" r="1.25" />
    <circle cx="6" cy="12" r="1.25" />
    <circle cx="10" cy="12" r="1.25" />
  </svg>
);

export const SparkleIcon = (props) => (
  <svg viewBox="0 0 16 16" width="16" height="16" fill="currentColor" aria-hidden {...props}>
    <path d="M8 1.5 9.3 5.4 13.2 6.7 9.3 8 8 11.9 6.7 8 2.8 6.7 6.7 5.4 8 1.5Z" />
    <path d="M12.8 10.4 13.4 12l1.6.6-1.6.6-.6 1.6-.6-1.6L10.6 12.6l1.6-.6.6-1.6Z" />
  </svg>
);

export const MoreIcon = (props) => (
  <svg viewBox="0 0 16 16" width="15" height="15" fill="currentColor" aria-hidden {...props}>
    <circle cx="8" cy="3.2" r="1.35" />
    <circle cx="8" cy="8" r="1.35" />
    <circle cx="8" cy="12.8" r="1.35" />
  </svg>
);

/* ---- Formula-specific ---- */

export const FlaskIcon = (props) => (
  <svg viewBox="0 0 16 16" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden {...props}>
    <path d="M6.25 1.75v4.1L2.6 12.1A1.4 1.4 0 0 0 3.8 14.25h8.4a1.4 1.4 0 0 0 1.2-2.15L9.75 5.85v-4.1" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5.5 1.75h5M4.6 9.75h6.8" strokeLinecap="round" />
  </svg>
);

export const ScaleIcon = (props) => (
  <svg viewBox="0 0 16 16" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden {...props}>
    <path d="M8 2.25v11.5M4 4.25h8" strokeLinecap="round" />
    <path d="M2.25 9.25 4 5.5l1.75 3.75a1.9 1.9 0 0 1-3.5 0ZM10.25 9.25 12 5.5l1.75 3.75a1.9 1.9 0 0 1-3.5 0Z" strokeLinejoin="round" />
  </svg>
);

// A numbered list: the making instructions, as opposed to the recipe.
export const StepsIcon = (props) => (
  <svg viewBox="0 0 16 16" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden {...props}>
    <path d="M6.5 4h7.25M6.5 8h7.25M6.5 12h7.25" strokeLinecap="round" />
    <path d="M2.25 2.75h1.5V5.5M2.4 10.4a1.1 1.1 0 1 1 1.85.8L2.3 13.25h2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const HistoryIcon = (props) => (
  <svg viewBox="0 0 16 16" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden {...props}>
    <path d="M2.5 8a5.5 5.5 0 1 0 1.7-4" strokeLinecap="round" />
    <path d="M2.25 2.25v3h3M8 5v3.2l2.2 1.3" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
